/**
 * DevExtreme (esm/__internal/core/ai_integration/commands/summarize.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import { BaseCommand } from "../../../core/ai_integration/commands/base";
export class SummarizeCommand extends BaseCommand {
  getTemplateName() {
    return "summarize";
  }
  buildPromptData(params) {
    return {
      user: {
        text: params.text
      }
    };
  }
  parseResult(response) {
    return response;
  }
}